import React, { useState, useMemo, useEffect } from "react";
import "./TransactionHistory.css";
import { getManageCreditsByBranchid } from "../../../services/hospitalServices";
import {
  pageChanged,
  pageLimit,
  setFilterBranch,
  updateStartDate,
  updateEndDate,
  searchKeyword,
  filterByTransactionType,
  filterByTransactionStatus,
} from "../../hospital/Redux/reducer";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CreditTransactionList, CreditTransactionListExport } from "../../hospital/Redux/actionCreator";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { filter } from "jszip";
import RefreshIcon from "@mui/icons-material/Refresh";




const TransactionHistory = ({ responseData, onRefresh }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // dispatch(filterBranch(selectedBranchObjectID));
  const [loading, setLoading] = useState(false);

  const { branch_Credit_Transaction } = useSelector((state) => state.hospital);
  const creditTransactionData =
    branch_Credit_Transaction?.branch_Credit_Transaction_info;
  console.log("creditTransactionData", creditTransactionData);

  const totalCount = branch_Credit_Transaction?.total;
  console.log("totalCount", totalCount);
  const currentPage = useSelector((state) => state.hospital.currentPage);
  const pageSize = useSelector((state) => state.hospital.pageSize);
  const filterBranchData = useSelector((state) => state.hospital.branch);
  const startDate = useSelector((state) => state.hospital.startDate);
  const endDate = useSelector((state) => state.hospital.endDate);
  const searchKey = useSelector((state) => state.hospital.searchKey);
  const transactionType = useSelector((state) => state.hospital.transactionType);
  const transactionStatus = useSelector(
    (state) => state.hospital.transactionStatus
  );

  const [inputStartDate, setInputStartDate] = useState("");
  const [inputEndDate, setInputEndDate] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [rotate, setRotate] = useState(false);
  

  useEffect(() => {
    if (responseData?._id) {
      console.log("Setting branch ID:", responseData._id);
      dispatch(setFilterBranch(responseData._id));
    }
  }, [responseData]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await dispatch(
        CreditTransactionList({
          currentPage: currentPage,
          pageSize: pageSize,
          branch: filterBranchData,
          startDate: startDate,
          endDate: endDate,
          searchKey: searchKey,
          transactionType: transactionType,
          transactionStatus: transactionStatus,
        })
      );
      setLoading(false);
    };

    fetchData();
  }, [
    dispatch,
    currentPage,
    pageSize,
    filterBranchData,
    startDate,
    endDate,
    searchKey,
    transactionType,
    transactionStatus,
  ]);
  

  const handleSearch = () => {
    const sanitizedSearchKey = inputValue.replace(/[+#^&*()$]/g, "");
    if (sanitizedSearchKey) {
           dispatch(searchKeyword(sanitizedSearchKey));
        } else {
    dispatch(updateStartDate(inputStartDate));
    dispatch(updateEndDate(inputEndDate));
    }
  };



  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };
  function formatDate() {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const formattedDate = `${day} ${month} ${year}_${hours}_${minutes}_${seconds}`;

    return formattedDate;
  }
  const handleExport = async () => {
    console.log("Export clicked");
    let csvData = "";
     const data = await dispatch(
      CreditTransactionListExport({
        branch: filterBranchData,
        startDate: startDate,
        endDate: endDate,
        searchKey: searchKey,
      })
            );
            console.log("data", data);
            csvData = data.payload.data;
          
    
          if (csvData && csvData.length > 0) {
            const blob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `TransactionHistory-${formatDate()}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
  };
}

 const handleReset = () => {
   // 🔹 Local input states reset
   setInputStartDate("");
   setInputEndDate("");
   setInputValue("");

   // 🔹 Redux filters reset
   dispatch(updateStartDate(""));
   dispatch(updateEndDate(""));
   dispatch(searchKeyword(""));
   dispatch(filterByTransactionType(""));
   dispatch(filterByTransactionStatus(""));

   // 🔹 Pagination reset (optional but recommended)
   dispatch(pageChanged(0));
 };

  return (
    <div className="transaction-container">
      <div className="transaction-wrapper">
        <div className="filters-box">
          <div>
            <label className="f-label">Start Date</label>
            <input
              type="date"
              className="input"
              value={inputStartDate}
              onChange={(e) => setInputStartDate(e.target.value)}
              onKeyPress={handleKeyPress}
            />
          </div>
          <div>
            <label className="f-label">End Date</label>
            <input
              type="date"
              className="input"
              value={inputEndDate}
              onChange={(e) => setInputEndDate(e.target.value)}
              onKeyPress={handleKeyPress}
            />
          </div>
          <div>
            <label className="f-label">Type</label>
            <select
              className="input"
              value={transactionType}
              onChange={(e) => {
                dispatch(filterByTransactionType(e.target.value));
              }}
            >
              <option value="">All</option>

              <option value="CREDIT_NOTE">Credit Note</option>
              <option value="DEBIT_NOTE">Debit Note</option>
              <option value="TOP_UP">Top Up</option>

              <option value="CHECKOUT_DECREMENT_BY_ADMIN">
                Checkout Decrement By Admin
              </option>

              <option value="CHECKOUT_INCREMENT_BY_ADMIN">
                Checkout Increment By Admin
              </option>

              <option value="JOB_EDITED_DECREMENT_BY_ADMIN">
                Job Edited Decrement By Admin
              </option>

              <option value="JOB_EDITED_INCREMENT_BY_ADMIN">
                Job Edited Increment By Admin
              </option>

              <option value="CHECKOUT_INCREMENT">Checkout Increment</option>

              <option value="CHECKOUT_DECREMENT">Checkout Decrement</option>

              <option value="JOB_EDITED_INCREMENT">Job Edited Increment</option>

              <option value="JOB_EDITED_DECREMENT">Job Edited Decrement</option>

              <option value="JOB_POSTED">Job Posted</option>
              <option value="JOB_CANCELED">Job Canceled</option>
              <option value="JOB_EXPIRED">Job Expired</option>
              <option value="JOB_EXTENDED">Job Extended</option>
            </select>
          </div>
          <div>
            <label className="f-label">Status</label>
            <select
              className="input"
              value={transactionStatus}
              onChange={(e) => {
                dispatch(filterByTransactionStatus(e.target.value));
              }}
            >
              <option value="">All</option>
              <option value="SUCCESS">Success</option>
              <option value="FAILED">Failed</option>
              <option value="PENDING">Pending</option>
            </select>
          </div>
          {/* RESET ICON ONLY */}
          <div
            className="reset-icon-wrapper"
            onClick={() => {
              setRotate(true);
              handleReset();
              setTimeout(() => setRotate(false), 300);
            }}
            title="Reset Filters"
            style={{
              marginTop: "26px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
          >
            <RefreshIcon
              sx={{
                color: "primary.main",
                transform: `${
                  rotate ? "rotate(-360deg)" : "rotate(0deg)"
                } scale(1.5)`,
                transition: "transform 0.3s ease",
              }}
            />
          </div>

          {/* EXPORT */}
          <div className="export-div-btn" onClick={handleExport}>
            Export
          </div>
          <div>
            <label className="f-label">Search</label>
            <input
              type="text"
              placeholder="Search by operator name or transaction ID"
              className="input"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyPress={handleKeyPress}
            />
          </div>
          {/* 🔽 DIV INSTEAD OF BUTTON */}
          <div className="search-div-btn" onClick={handleSearch}>
            Search
          </div>
        </div>

        <div className="table-wrapper">
          <table className="transaction-table">
            <thead>
              <tr>
                <th className="col-medium">Date/Time</th>
                <th className="col-large">Transaction ID</th>
                <th className="col-small">Type</th>
                <th className="col-small">Amount</th>
                <th className="col-small">Method</th>
                <th className="col-small">Initiated By</th>
                <th className="col-small">Status</th>
                <th className="col-small col-balance">Balance Change</th>
                <th className="col-small">Actions</th>
              </tr>
            </thead>

            <tbody>
              {creditTransactionData?.map((item, index) => (
                <tr key={index}>
                  {/* <td>
                    {new Date(item.createdAt).toLocaleDateString("en-GB")}
                  </td> */}
                  <td>
                    {new Date(item.createdAt).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    })}
                  </td>

                  {/* <td>{item.transactionId}</td> */}
                  <td
                    style={{
                      borderLeft: "none",
                      borderRight: "none",
                      // borderBottom: "none",
                      verticalAlign: "middle",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                    >
                      <span>{item.transactionId}</span>

                      <ContentCopyIcon
                        fontSize="small"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          navigator.clipboard.writeText(item.transactionId);
                          toast.success("Copied");
                        }}
                      />
                    </div>
                  </td>

                  <td>{item.type}</td>

                  <td
                    className={
                      item.type === "DEBIT_NOTE"
                        ? "amount-negative"
                        : "amount-positive"
                    }
                  >
                    {(() => {
                      let value = 0;
                      let sign = "";

                      switch (item.type) {
                        case "TOP_UP":
                          value = item.amount;
                          sign = "+";
                          break;

                        case "CREDIT_NOTE":
                          value = item.adjustmentCreditAmount;
                          sign = "+";
                          break;

                        case "DISCOUNT":
                        case "DEBIT_NOTE":
                        case "REFUND":
                          value = item.adjustmentCreditAmount;
                          sign = "-";
                          break;

                        default:
                          value = 0;
                          sign = "";
                      }

                      return `${sign} ₹${Math.abs(value)}`;
                    })()}
                  </td>

                  <td>{item.method}</td>
                  <td>{`${item?.initiatedBy}`}</td>

                  <td>
                    <span
                      className={
                        item.status === "SUCCESS"
                          ? "status-posted"
                          : "status-pending"
                      }
                    >
                      {item.status}
                    </span>
                  </td>

                  <td className="balance-col">
                    <div className="balance-line">₹{item.beforeBalance}</div>
                    <div className="balance-arrow">↓</div>
                    <div className="balance-line">₹{item.afterBalance}</div>
                  </td>

                  <td className="actions-cell">👁️</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="pagination-container">
            <div className="rows-per-page">
              Rows per page:
              <select
                value={pageSize}
                onChange={(e) => dispatch(pageLimit(Number(e.target.value)))}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>

            <div className="page-info">
              {totalCount > 0
                ? `${currentPage * pageSize + 1}–${Math.min(
                    (currentPage + 1) * pageSize,
                    totalCount
                  )} of ${totalCount}`
                : "0 of 0"}
            </div>

            <div className="pagination-buttons">
              {/* LEFT ARROW */}
              <button
                disabled={currentPage === 0}
                onClick={() => dispatch(pageChanged(currentPage - 1))}
              >
                &#8249;
              </button>

              {/* RIGHT ARROW */}
              <button
                disabled={(currentPage + 1) * pageSize >= totalCount}
                onClick={() => dispatch(pageChanged(currentPage + 1))}
              >
                &#8250;
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionHistory;
